import React from "react";
import {useSelector} from "react-redux";
import {RootState} from "../../../store/rootReducer";
import {SearchCard} from "./card/searchCard";
import styled from "styled-components";
import {ThemeProps} from "../../../styles/theme";

const Root = styled.div`
    display: flex;
    flex-direction: column;
`;

const NoResultsMessage = styled.div<ThemeProps>`
    text-align: center;
    padding: 30px;
    color: ${(props): string => props.theme.secondaryText};
`;

interface SearchResultProps {
}

// Используем React.FC для правильной типизации
export const SearchResult: React.FC<SearchResultProps> = (_props) => {
    const {items} = useSelector((state: RootState) => ({
        items: state.search.items,
    }));

    // Список найденных элементов

    const cardViews = items.map(item => (
        <SearchCard
            key={item.id}
            id={item.id}
            type={item.type}
            title={item.title}
            subTitle={item.subTitle}
            mark={item.mark}
        />
    ));

    const hasResults = items.length > 0;
    const isLoading = false;

    return (
        <Root>
            {isLoading && (
                <NoResultsMessage>Loading...</NoResultsMessage>
            )}
            
            {!isLoading && !hasResults && (
                <NoResultsMessage>No results found</NoResultsMessage>
            )}

            {cardViews}
        </Root>
    );
};